export function fileRead(file: File): Promise<string> {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      resolve(e.target?.result?.toString() || '')
    }
    reader.readAsDataURL(file)
  })
}
